const FREQUENCY_NUMBER_LIMIT = 3;

const MONTHLY_FREQUENCY_VALUE = 12;

export const headerContainerStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  columnGap: '24px',
};

export const impoundContainerStyles = {
  display: 'flex',
  border: '1px solid',
  borderColor: ({ palette }) => palette.border.default,
  borderBottom: 'none',

  '&:first-of-type': {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },

  '&:nth-last-of-type(2)': {
    marginBottom: '10px',
    borderBottom: '1px solid',
    borderBottomColor: ({ palette }) => palette.border.default,
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
  },
};

export const rowFormContainerStyles = {
  flex: 1,

  padding: '15px',
  paddingBottom: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const gridTopRowContainerStyles = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '0.24fr repeat(5, 0.15fr)',
  columnGap: '30px',

  '& input.MuiInputBase-input': {
    padding: '6px 8px !important',
  },

  '& .MuiInputAdornment-positionStart': {
    '& > .MuiTypography-root': {
      padding: '0 12px !important',
    },
  },
};

export const getGridDueDatesContainerStyles = ({ frequencyNumber }) => ({
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gridTemplateRows: frequencyNumber
    ? `repeat(${frequencyNumber === MONTHLY_FREQUENCY_VALUE ? FREQUENCY_NUMBER_LIMIT : 1}, 1fr)`
    : '1fr',
  columnGap: '24px',
  rowGap: '20px',

  '& input.MuiInputBase-input': {
    padding: '5px 8px !important',
  },
  '& .MuiInputAdornment-positionStart': {
    height: '30px !important',

    '& > .MuiTypography-root': {
      padding: '0 12px !important',
    },
  },
});

export const dueDateContainerStyles = {
  display: 'flex',
  gap: '12px',
};

export const deleteButtonStyles = {
  padding: '33px 24px',
  height: 'fit-content',
};
